import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface VideoUploadEntry {
  uploadId: string;
  title: string;
  thumbnailUrl: string;
  percentage: string;
  status: "uploading" | "processing" | "complete" | "error";
  slug?: string;
  _id?: string;
}
import { isClaimPendingUser, roleType } from "../../global";
import { handleGoogleLogout } from "../../utils/constants";

const initialState = {
  registerData: {},
  regPmtAtTk: null,
  userDetails: {},
  bulkUserData: {},
  editData: {},
  token: "",
  quicklogin: {},
  userDirectoryDetails: {},
  latLongLocation: {},
  getProfilePicture: "",
  videoInfo: [],
  searchFilters: {},
  allfeedscategory: [],
  liveStreamData: {},
  allfeedsFilters: {
    tagsForFilters: [],
    duration: [],
    fromDate: "",
    toDate: "",
    page: 1,
  },
  followingfeedsFilter: {
    tagsForFilters: [],
    duration: [],
    fromDate: "",
    toDate: "",
    page: 1,
  },
  localfeedsFilter: {
    tagsForFilters: [],
    duration: [],
    fromDate: "",
    toDate: "",
    page: 1,
  },
  localfeedsCategory: [],
  nationalfeedsFilter: {
    tagsForFilters: [],
    duration: [],
    fromDate: "",
    toDate: "",
    page: 1,
  },
  nationalfeedsCategory: [],
  globalfeedsFilter: {
    tagsForFilters: [],
    duration: [],
    fromDate: "",
    toDate: "",
    page: 1,
  },
  globalfeedsCategory: [],
  searchTagFilters: {
    availability: [],
    insurance: [],
    ages: [],
    faith: [],
    price: [],
    forQuery: [],
    conditions: [],
    audience: [],
    status: "",
    category: [],
    therapies: [],
    search: "",
  },
  viewProfileActiveTab: "about",
  previousRoute: "/",
  categoryDetails: {},
  subCategoryDetails: {},
  groupCategoryDetails: {},
  subGroupCategoryDetails: {},
  notificationUnReadCount: 0,
  slotTime: {},
  slotDate: {},
  clientDob: null,
  expiryToken: "",
  worldWideToken: {},
  tabLocation: "",
  wwSlotId: "",
  editScheduleData: {},
  providerEncryptedId: "",
  blogId: "",
  subscriptionDetails: {},
  subscriptionStatus: "",
  promoCodeDiscountDetails: {},
  promoCode: "",
  ticketEditData: {},
  replyClientTicket: "",
  menuList: [],
  // Navigation CMS list (cms/navigation/list) — fetched once by the header;
  // the footer reads it from here instead of re-fetching the same URL (two
  // independent fetches to the same URL abort each other, see getData's
  // per-URL AbortController keying in services/api.service.tsx).
  navMenuList: [],
  rolesPermission: {},
  assetList: [],
  assetListLoading: false,
  assetImageList: {},
  preDefinedPageList: [],
  homeSectionList: [],
  homeSectionMetaData: {},
  selectedMenu: "",
  selectedSubMenu: "",
  videoLoader: {},
  videoUploads: [] as VideoUploadEntry[],
  addVideoListRefreshTrigger: 0,
  promoCodeData: "",
  writtenContentEditData: {},
  searchByLocation: {},
  repIdAndDiscountDetails: {},
  filterAllselectedValue: {},
  globalSettings: {},
  wellcomePopup: true,
  providerCount: [],
  providerType: "",
  selectedPlanPrice: 0,
  providerRole: "",
  referralCount: 0,
  referralCode: null,
  referralChannel: null,
  referralIsSalesRep: false,
  referralSummary: null as any,
  locationPermissionModal: false,
};

const CommonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    // Auth related
    setRegisterData: (state, { payload }) => {
      state.registerData = payload;
    },
    setQuickLoginData: (state, { payload }) => {
      state.quicklogin = payload;
    },
    setLoginAuthToken: (state, { payload }) => {
      state.token = payload;
    },
    setBulkUserData: (state, { payload }) => {
      state.bulkUserData = payload;
    },
    removeAuthToken: (state) => {
      state.token = "";
      localStorage.removeItem("token");
      // window.location.href = `/${roleType()}/login`;
      localStorage.removeItem("role");
      state.userDetails = {};
    },
    setUserDetails: (state, { payload }) => {
      state.userDetails = payload;
      // Claimed-but-not-completed providers bypass the restriction flow.
      if (isClaimPendingUser(payload)) {
        state.userDetails.account_restricted = false;
      }
      if (!payload || Object.keys(payload).length === 0) {
        state.token = "";
        localStorage.removeItem("token");
        localStorage.removeItem("role");
      }
    },
    setSubscriptionDetails: (state, { payload }) => {
      state.subscriptionDetails = payload;
    },
    setSubscriptionStatus: (state, { payload }) => {
      state.subscriptionStatus = payload;
    },
    setEditData: (state, { payload }) => {
      state.editData = payload;
    },
    setUserDirectoryDetails: (state, { payload }) => {
      state.userDirectoryDetails = payload;
      // Claimed-but-not-completed providers bypass the restriction flow.
      if (isClaimPendingUser(payload)) {
        state.userDirectoryDetails.account_restricted = false;
      }
    },
    setLatLongLocation: (state, { payload }) => {
      state.latLongLocation = payload;
    },
    setProfileImage: (state, { payload }) => {
      state.getProfilePicture = payload;
    },
    setPreviousRoute: (state, { payload }) => {
      state.previousRoute = payload;
    },
    setCategoryDetails: (state, { payload }) => {
      state.categoryDetails = payload;
    },
    setSubCategoryDetails: (state, { payload }) => {
      state.subCategoryDetails = payload;
    },
    setGroupCategoryDetails: (state, { payload }) => {
      state.groupCategoryDetails = payload;
    },
    setSubGroupCategoryDetails: (state, { payload }) => {
      state.subGroupCategoryDetails = payload;
    },
    setNotificationUnReadCount: (state, { payload }) => {
      state.notificationUnReadCount = payload;
    },
    setVideoInfo: (state, { payload }) => {
      state.videoInfo = payload;
    },
    setSearchFilters: (state, { payload }) => {
      state.searchFilters = payload;
    },
    setAllfeedsCategory: (state, { payload }) => {
      state.allfeedscategory = payload;
    },
    setLiveStreamData: (state, { payload }) => {
      state.liveStreamData = payload;
    },
    setAllfeedsFilters: (state, { payload }) => {
      state.allfeedsFilters = {
        ...state.allfeedsFilters,
        ...payload,
      };
    },
    setFollowingFeedsFilter: (state, { payload }) => {
      state.followingfeedsFilter = {
        ...state.followingfeedsFilter,
        ...payload,
      };
    },
    setLocalFeedsFilter: (state, { payload }) => {
      state.localfeedsFilter = {
        ...state.localfeedsFilter,
        ...payload,
      };
    },
    setLocalfeedsCategory: (state, { payload }) => {
      state.localfeedsCategory = payload;
    },
    setNationalFeedsFilter: (state, { payload }) => {
      state.nationalfeedsFilter = {
        ...state.nationalfeedsFilter,
        ...payload,
      };
    },
    setNationalfeedsCategory: (state, { payload }) => {
      state.nationalfeedsCategory = payload;
    },
    setGlobalFeedsFilter: (state, { payload }) => {
      state.globalfeedsFilter = {
        ...state.globalfeedsFilter,
        ...payload,
      };
    },

    setGlobalfeedsCategory: (state, { payload }) => {
      state.globalfeedsCategory = payload;
    },
    setSearchTagFilter: (state, { payload }) => {
      state.searchTagFilters = {
        ...state.searchTagFilters,
        ...payload,
      };
    },
    setViewProfileActiveTab: (state, { payload }) => {
      state.viewProfileActiveTab = payload;
    },
    setRegPmtAtTk: (state, { payload }) => {
      state.regPmtAtTk = payload;
    },
    setWwSlotDate: (state, { payload }) => {
      state.slotDate = payload;
    },
    setWwSlotTime: (state, { payload }) => {
      state.slotTime = payload;
    },
    setClientDob: (state, { payload }) => {
      state.clientDob = payload;
    },
    setWwExpiryToken: (state, { payload }) => {
      state.expiryToken = payload;
    },
    setWorldWideToken: (state, { payload }) => {
      state.worldWideToken = payload;
    },
    setWwSlotId: (state, { payload }) => {
      state.wwSlotId = payload;
    },
    setTabLocation: (state, { payload }) => {
      state.tabLocation = payload;
    },
    setEditScheduleData: (state, { payload }) => {
      state.editScheduleData = payload;
    },
    setProviderEncryptedId: (state, { payload }) => {
      state.providerEncryptedId = payload;
    },
    setBlogId: (state, { payload }) => {
      state.blogId = payload;
    },
    setPromoCodeDiscountDetails: (state, { payload }) => {
      state.promoCodeDiscountDetails = payload;
    },
    setPromoCode: (state, { payload }) => {
      state.promoCode = payload;
    },
    setTicketEditData: (state, { payload }) => {
      state.ticketEditData = payload;
    },
    setReplyClientTicket: (state, { payload }) => {
      state.replyClientTicket = payload;
    },
    setMenulist: (state, { payload }) => {
      state.menuList = payload;
    },
    setNavMenuList: (state, { payload }) => {
      state.navMenuList = payload;
    },
    setRolesPermission: (state, { payload }) => {
      state.rolesPermission = payload;
    },
    setAssetList: (state, { payload }) => {
      state.assetList = payload;
    },
    setAssetListLoading: (state, { payload }) => {
      state.assetListLoading = payload;
    },
    setAssetImageList: (state, { payload }) => {
      state.assetImageList = payload;
    },
    setPreDefinedPageList: (state, { payload }) => {
      state.preDefinedPageList = payload;
    },
    setHomeSectionList: (state, { payload }) => {
      state.homeSectionList = payload;
    },
    setHomeSectionMetaData: (state, { payload }) => {
      state.homeSectionMetaData = payload;
    },
    setSelectedMenu(state, action) {
      state.selectedMenu = action.payload;
      state.selectedSubMenu = ""; // reset submenu on menu change
    },
    setSelectedSubMenu(state, action) {
      state.selectedSubMenu = action.payload;
    },
    setVideoLoader(state, action) {
      state.videoLoader = action.payload;
    },
    addVideoUpload(state, action: PayloadAction<VideoUploadEntry>) {
      state.videoUploads.push(action.payload);
    },
    updateVideoUpload(
      state,
      action: PayloadAction<Partial<VideoUploadEntry> & { uploadId: string }>,
    ) {
      const { uploadId, ...updates } = action.payload;
      const idx = state.videoUploads.findIndex((u) => u.uploadId === uploadId);
      if (idx !== -1) {
        state.videoUploads[idx] = { ...state.videoUploads[idx], ...updates };
      }
    },
    removeVideoUpload(state, action: PayloadAction<string>) {
      state.videoUploads = state.videoUploads.filter((u) => u.uploadId !== action.payload);
    },
    clearAllVideoUploads(state) {
      state.videoUploads = [];
    },
    triggerAddVideoListRefresh(state) {
      state.addVideoListRefreshTrigger += 1;
    },
    setPromoCodeData(state, action) {
      state.promoCodeData = action.payload;
    },
    setWrittenContentEditData(state, action) {
      state.writtenContentEditData = action.payload;
    },
    setSearchByLocation(state, action) {
      state.searchByLocation = action.payload;
    },

    setRepIdAndDiscountDetails(state, action) {
      state.repIdAndDiscountDetails = action.payload;
    },
    setFilterAllselectedValue(state, action) {
      state.filterAllselectedValue = action.payload;
    },
    setGlobalSettings(state, action) {
      state.globalSettings = action.payload;
    },
    setAccountRestricted(state, action) {
      const userDetails: any = state.userDetails;
      userDetails.account_restricted = isClaimPendingUser(userDetails) ? false : action.payload;
      state.userDetails = userDetails;
    },
    setWellcomePopup: (state, action) => {
      state.wellcomePopup = action.payload;
    },
    setProviderTypeRole: (state, action) => {
      state.providerType = action.payload;
    },
    setUserDetailsCredentialAgreeTerms(state, action) {
      const userDetails: any = state.userDetails;
      if (userDetails?.primary_credential_setting?.[0]) {
        userDetails.primary_credential_setting[0].credential_agree_terms = action.payload;
      }
      state.userDetails = userDetails;
    },
    setProviderCount: (state, { payload }) => {
      state.providerCount = payload;
    },
    setSelectedPlanPrice: (state, { payload }) => {
      state.selectedPlanPrice = payload;
    },
    setProviderRole: (state, { payload }) => {
      state.providerRole = payload;
    },
    setReferralCount: (state, { payload }) => {
      state.referralCount = payload;
    },
    setReferralCode: (state, { payload }) => {
      state.referralCode = payload;
    },
    setReferralChannel: (state, { payload }) => {
      state.referralChannel = payload;
    },
    setReferralIsSalesRep: (state, { payload }) => {
      state.referralIsSalesRep = payload;
    },
    setReferralSummary: (state, { payload }) => {
      state.referralSummary = payload;
    },
    setLocationPermissionModal: (state, { payload }) => {
      state.locationPermissionModal = payload;
    },
  },
});

export const {
  setRegisterData,
  setQuickLoginData,
  setUserDetails,
  setSubscriptionDetails,
  setSubscriptionStatus,
  setEditData,
  setLoginAuthToken,
  removeAuthToken,
  setUserDirectoryDetails,
  setLatLongLocation,
  setProfileImage,
  setVideoInfo,
  setSearchFilters,
  setAllfeedsCategory,
  setAllfeedsFilters,
  setLiveStreamData,
  setViewProfileActiveTab,
  setRegPmtAtTk,
  setFollowingFeedsFilter,
  setLocalFeedsFilter,
  setLocalfeedsCategory,
  setNationalFeedsFilter,
  setNationalfeedsCategory,
  setGlobalFeedsFilter,
  setGlobalfeedsCategory,
  setSearchTagFilter,
  setPreviousRoute,
  setCategoryDetails,
  setSubCategoryDetails,
  setGroupCategoryDetails,
  setNotificationUnReadCount,
  setWwSlotTime,
  setClientDob,
  setWwExpiryToken,
  setWwSlotDate,
  setWorldWideToken,
  setTabLocation,
  setWwSlotId,
  setEditScheduleData,
  setProviderEncryptedId,
  setBlogId,
  setPromoCodeDiscountDetails,
  setPromoCode,
  setTicketEditData,
  setReplyClientTicket,
  setMenulist,
  setNavMenuList,
  setSubGroupCategoryDetails,
  setRolesPermission,
  setAssetList,
  setAssetListLoading,
  setAssetImageList,
  setPreDefinedPageList,
  setHomeSectionList,
  setHomeSectionMetaData,
  setSelectedMenu,
  setSelectedSubMenu,
  setVideoLoader,
  addVideoUpload,
  updateVideoUpload,
  removeVideoUpload,
  clearAllVideoUploads,
  triggerAddVideoListRefresh,
  setWrittenContentEditData,
  setPromoCodeData,
  setSearchByLocation,
  setBulkUserData,
  setRepIdAndDiscountDetails,
  setFilterAllselectedValue,
  setGlobalSettings,
  setAccountRestricted,
  setWellcomePopup,
  setUserDetailsCredentialAgreeTerms,
  setProviderCount,
  setProviderTypeRole,
  setSelectedPlanPrice,
  setProviderRole,
  setReferralCount,
  setReferralCode,
  setReferralChannel,
  setReferralIsSalesRep,
  setReferralSummary,
  setLocationPermissionModal,
} = CommonSlice.actions;

export default CommonSlice.reducer;
